import gql from 'graphql-tag';

export default gql`
mutation ReviewDecline(
        $uuids: String!
      ) {
    reviewDecline(uuids: $uuids) {
      __typename
    }
}
`;
